import { ModuleWithProviders, NgModule } from '@angular/core';

import { Environment } from '@sc/data-access-models';

import { ENV_CONFIG } from './services/environment/environment.provider';

@NgModule({
  imports: [],
})
export class DataAccessEnvironmentModule {
  static forRoot(
    environment: Environment
  ): ModuleWithProviders<DataAccessEnvironmentModule> {
    return {
      ngModule: DataAccessEnvironmentModule,
      providers: [
        {
          provide: ENV_CONFIG,
          useValue: environment,
        },
      ],
    };
  }
}
